import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccountStatus } from '@app/enum/account/AccountStatus';
import { Platform } from '@app/enum/account/Platform';
import { ResourceType } from '@app/enum/ResourceType';
import { IAccount } from '@app/services/account.service';
import { LoginService } from '@app/services/login.service.ajs';
import { NavigationService } from '@app/services/navigation.service';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IResellerAccountMapping, ResellerAccountMappingService } from '../../../../../../services/resellerAccountMapping.service';
import { FoundationNavigationModule } from '../../../foundation.navigation';
import { AccountService } from '../../../_services/account.service';
import './customer-view.component.scss';

@Component({
    selector: 'foundation-customer-view',
    template: require('./customer-view.component.html')
})
export class CustomerViewComponent implements OnInit {
    @Output() tabChanged = new EventEmitter<void>();
    loading = false;

    customerId: number;
    customer: IAccount;
    customerImage$: Observable<string>;

    showEditor: boolean;

    AccountStatus = AccountStatus;
    Platform = Platform;

    resourceType = ResourceType.Account;

    customerAccountModel$: Observable<{ customer: IAccount, mappings: IResellerAccountMapping[] }>;

    constructor(
        private readonly accountService: AccountService,
        private readonly loginService: LoginService,
        private readonly navigationService: NavigationService,
        private readonly resellerAccountMappingService: ResellerAccountMappingService ) { }

    ngOnInit() {
        this.customerId = this.navigationService.getRouteParam('customerId');
        this.getData();
    }

    login() {
        this.loading = true;

        this.loginService.switchAccount(this.customerId, true);
    }

    editCustomer(): void {
        this.navigationService.go(FoundationNavigationModule.CustomerEdit, { customerId: this.customerId });
    }

    hideEditor(): void {
        this.showEditor = false;
    }

    //--

    private getData(): void {
        this.getCustomerAccount();

        this.getCustomerImage();        
    }

    private getCustomerAccount(): void {
        let accountName: string = 'Customer Name';

        const customerAccount$: Observable<IAccount> = this.accountService.getCustomerAccount(this.customerId).pipe(
            tap(account => {
                accountName = account.CompanyName;

                this.navigationService.updateTitle(accountName);
            })
        );

        const resellerMappings$: Observable<IResellerAccountMapping[]> = this.resellerAccountMappingService.getMappings({ AccountId: this.customerId }, true);

        this.customerAccountModel$ = combineLatest([
            customerAccount$,
            resellerMappings$
        ]).pipe(
            map(([customer, mappings]) => ({ customer, mappings }))
        );
    }

    private getCustomerImage(): void {
        this.customerImage$ = this.accountService.getCustomerAccountImage(this.customerId);
    }
}
